import { render, staticRenderFns } from "./ResultDetailTitle.vue?vue&type=template&id=2b450ebe&scoped=true&"
import script from "./ResultDetailTitle.vue?vue&type=script&lang=js&"
export * from "./ResultDetailTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b450ebe",
  null
  
)

export default component.exports